import AppConsts from '@/lib/AppConsts';
import Axios from 'axios';
import { extend } from '@/lib/utils/extend';
import Util from '@/lib/util';
var AbpAxios = /** @class */ (function () {
    function AbpAxios() {
        this.ajaxUrl = process.env.VUE_APP_API_URL || '';
        this.ajax = this.CreateAxiosInstance();
    }
    AbpAxios.prototype.CreateAxiosInstance = function () {
        var instance = Axios.create({
            baseURL: this.ajaxUrl,
            timeout: 30000
        });
        instance.interceptors.request.use(function (config) {
            if (abp.auth.getToken()) {
                config.headers.common.Authorization = 'Bearer ' + abp.auth.getToken();
            }
            config.headers.common['.AspNetCore.Culture'] = abp.utils.getCookieValue('Abp.Localization.CultureName');
            config.headers.common['Abp.TenantId'] = abp.multiTenancy.getTenantIdCookie();
            config.headers.common['Hamazon.BrowserIdentity'] = Util.BrowserIdentity;
            config.headers.common['Hamazon.Platform'] = AppConsts.platform;
            return config;
        }, function (error) {
            return Promise.reject(error);
        });
        instance.interceptors.response.use(function (response) {
            return response;
        }, function (error) {
            // Do something with response error
            if (error.response && error.response.data && error.response.data.__abp) {
                abp.ajax.showError(error.response.data.error);
            }
            else {
                if (!error.response) {
                    abp.ajax.showError(abp.ajax.defaultError);
                    return;
                }
                switch (error.response.status) {
                    case 401:
                        abp.ajax.handleUnAuthorizedRequest(abp.ajax.showError(abp.ajax.defaultError401), abp.appPath);
                        break;
                    case 403:
                        abp.ajax.showError(abp.ajax.defaultError403);
                        break;
                    case 404:
                        abp.ajax.showError(abp.ajax.defaultError404);
                        break;
                    default:
                        abp.ajax.showError(abp.ajax.defaultError);
                        break;
                }
            }
            return Promise.reject(error);
        });
        return instance;
    };
    return AbpAxios;
}());
// tslint:disable-next-line:no-namespace
var abpAxios = {
    ajax: new AbpAxios().ajax
};
var abpAjax = (extend(true, abpAxios.ajax, window.abp.ajax));
export var thisAbp = extend(true, window.abp, { ajax: abpAjax });
window.abp = thisAbp;
